const about =
{
    alternateName :
    {
        caption  : 'Titre principal de l\'objet.',
        title    : 'Titre' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    },
    description :
    {
        caption  : 'Une description courte de l\'objet.',
        title    : 'Description' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    },
    notes :
    {
        caption  : 'Anectdotes, remarques, etc. ',
        title    : 'Notes' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    },
    text :
    {
        caption  : 'Texte principal de l\'objet.',
        title    : 'Texte' ,
        tooltips :
        {
            refresh : 'Annuler' ,
            save    : 'Enregister'
        }
    }
};

export default about ;
